"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserSettings = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var get_1 = (0, tslib_1.__importDefault)(require("lodash/fp/get"));
var ViewPreferenceApiService_1 = require("../services/ViewPreferenceApiService");
var useUserSettings = function () {
    var _a = (0, react_1.useState)(true), loading = _a[0], setLoading = _a[1];
    var _b = (0, react_1.useState)(null), data = _b[0], setData = _b[1];
    (0, react_1.useEffect)(function () {
        var getUserSettings = function () { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
            var res, userSettings;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ViewPreferenceApiService_1.ViewPreferenceApiService.get('/settings/{userId}')];
                    case 1:
                        res = _a.sent();
                        userSettings = (0, get_1.default)('data[0]', res);
                        setData(userSettings);
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        getUserSettings();
    }, []);
    return { data: data, loading: loading };
};
exports.useUserSettings = useUserSettings;
